import { Provider } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Observable } from 'rxjs';

class CacheBustingTranslateLoader implements TranslateLoader {
  constructor(
    private readonly http: HttpClient,
    private readonly version: string
  ) {}

  getTranslation(lang: string): Observable<TranslationObject> {
    return this.http.get<TranslationObject>(
      `/assets/i18n/${lang}.json?v=${this.version}`
    );
  }
}

export const translationHttpLoaderFactory = (): Provider => ({
  provide: TranslateLoader,
  useFactory: (http: HttpClient, meta: Meta): CacheBustingTranslateLoader => {
    const versionMetaTag = meta.getTag('name=version');
    const version = versionMetaTag
      ? versionMetaTag.content
      : new Date().getTime().toString();

    return new CacheBustingTranslateLoader(http, version);
  },
  deps: [HttpClient, Meta]
});
